import lr from './lr.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <nav className="navbar">
        <img src={lr} className="nav-logo" alt="logo" />
        
      </nav>

      <header className="App-header">
        <div className="hero-wrapper">
          <h1 className="hero">Work in progress</h1>
          <img src="/work.png" alt="work" className="hero-image" />
        </div>
      </header>
    </div>
  );
}

export default App;
